import { AppBar, Box, Divider, Drawer, IconButton, Toolbar, Typography } from "@mui/material";
import { React, useState, useEffect } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { NavLink } from "react-router-dom";
// import Logo from '../../../src/images/logo.png'
import './Header.css'
// import List from "../../pages/List/List";

const Header = () => {
  const [mobileOpen, setMbbileOpen] = useState(false);

  const [isSticky, setIsSticky] = useState(false);
  // const [seen, setSeen] = useState(false) 

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // handle menu click
  const handleDrawerToggle = () => {
    setMbbileOpen(!mobileOpen);
  };
  //menu drawer
  const drawer = (
    <Box onClick={handleDrawerToggle}
      sx={{ textAlign: "center" }}>
      <Typography
        color={"goldenrod"}
        variant="h6"
        component="div"
        sx={{ flexGrow: 1, my: 2 }}
      >
        <Typography
          color={"#000"}
          variant="h4"
          component={"h4"}
          className="logo"
        >
          Abhishek
        </Typography>
      </Typography>
      <Divider />

      <ul className="mobile-navigation-menu">
        <li>
          <NavLink activeclassname='active' to={"/"}>
            HOME
          </NavLink>
        </li>
        <li>
          <NavLink className='education' to={"/education"}>
            Education
          </NavLink>
        </li>
        <li>
          <NavLink to={"/skills"} >
            Skills
          </NavLink>
        </li>
        <li>
          <NavLink className='pro' to={'/project'} >
            Projects
          </NavLink>
        </li>
        <li>
          <NavLink className='contact' to={'/contact'} >
            Contact
          </NavLink>
        </li>
        <li>
          <NavLink className='tryToFun' to={'/trytofun'} >
            Try to Fun
          </NavLink>
        </li>

      </ul>

    </Box>
  );

  return (
    <>
      <Box className={`navbar ${isSticky ? ' sticky' : ''}`}>
        <AppBar className="appBar" component={"nav"} sx={{ bgcolor: "#fff" }}>
          <Toolbar>
            <IconButton
              color="secondary"
              aria-label="open drawer"
              edge="start"
              sx={{ mr: 2, display: { sm: "none" } }}
              onClick={handleDrawerToggle}
            >
              <MenuIcon />
            </IconButton>

            <Typography
              color={"#000"}
              variant="h4"
              component={"h4"}
              className="logo"
            >
              Abhishek
            </Typography>
            <Box sx={{
              display: {
                xs: "none",
                sm: "block",
                mr: 4
              }
            }}>
              <ul className="navigation-menu">
                <li>
                  <NavLink activeclassname='active' to={"/"} className='home active-link'>
                    HOME
                  </NavLink>
                </li>
                <li>
                  <NavLink activeclassname='active' className='education active-link' to={"/education"}>
                    Education
                  </NavLink>
                </li>
                <li>
                  <NavLink activeclassname='active' to={"/skills"} >
                    Skills
                  </NavLink>
                </li>
                <li className='projects'>
                  <NavLink activeclassname='active' className='pro' to={'/project'}   >
                    Projects
                  </NavLink>
                </li>
                <li>
                  <NavLink activeclassname='active' className='contact' to={'/contact'}  >
                    Contact
                  </NavLink>
                </li>
                <li>
                  <NavLink activeclassname='active' className='tryToFun' to={'/trytofun'} >
                    Try to Fun
                  </NavLink>
                </li>

              </ul>
            </Box>
          </Toolbar>
        </AppBar>
        <Box component={"nav"}>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "240px",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>
        <Toolbar />
      </Box>
    </>
  );
};

export default Header;